var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4499 3.10001C8.23134 3.6342 6.33084 5.38857 5.18678 6.31257C4.85673 6.00676 4.50889 5.72072 4.14509 5.45595C2.55434 4.29395 0.649902 4.15001 0.649902 4.15001C0.649902 4.15001 1.14734 6.40445 2.4594 7.64257C1.14734 8.88113 0.649902 11.1356 0.649902 11.1356C0.649902 11.1356 2.55434 10.9916 4.14509 9.82963C4.50582 9.56715 4.85073 9.2836 5.17803 8.98045C6.3199 9.90532 8.22915 11.6641 10.4499 12.2L9.7499 14.65C11.475 14.3582 13.2 13.0964 13.8939 12.5391C19.5499 12.2875 21.6499 8.65626 21.6499 7.65001C21.6499 6.68751 19.5499 3.01251 13.911 2.76182C13.2289 2.21538 11.4894 0.944009 9.7499 0.650009L10.4499 3.10001Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1497 7.64959C18.5363 7.64959 18.8497 7.33619 18.8497 6.94959C18.8497 6.56299 18.5363 6.24959 18.1497 6.24959C17.7631 6.24959 17.4497 6.56299 17.4497 6.94959C17.4497 7.33619 17.7631 7.64959 18.1497 7.64959Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5038 12.025C15.7324 10.696 15.3262 9.18665 15.3262 7.65001C15.3262 6.11337 15.7324 4.60404 16.5038 3.27501",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeMiterlimit: 20,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFish);
export default __webpack_public_path__ + "static/media/fish.0217b913e084243b59bf3b99bc10cdc3.svg";
export { ForwardRef as ReactComponent };